/* unplugin-vue-components disabled */import script from "./MenuTip.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTip.vue?vue&type=script&setup=true&lang=js"

import "./MenuTip.vue?vue&type=style&index=0&id=28c1d6e9&lang=scss"

const __exports__ = script;

export default __exports__